import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "py-1" }
const _hoisted_5 = {
  key: 0,
  class: "inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800"
}
const _hoisted_6 = { class: "py-1" }
const _hoisted_7 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import { isTheSameDomain } from '@/common/domainName';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { MX, QueryResult, RecordInfo } from '@/model/Api';

type MxRecordWithInfo = {
  record: MX;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'MxRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: MxRecordWithInfo[] = props.records.response.answer.filter((item): item is MxRecordWithInfo => item.record.recordType === 'MX');
  processed.sort((a, b) => a.record.priority - b.record.priority);

  return processed;
});

const minPriority = computed(() => Math.min(...processedRecords.value.map((r) => r.record.priority)));

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { class: "w-2/4" }),
            _createElementVNode("col", { class: "w-1/4" }),
            _createElementVNode("col", { class: "w-1/4" })
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Mail server"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Priority"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", _hoisted_2, [
                  (_unref(isTheSameDomain)(__props.records.query.domain, record.record.target))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.record.target), 1))
                    : (_openBlock(), _createBlock(DnsRecordsLink, {
                        key: 1,
                        domain: record.record.target,
                        class: "text-blue-600 hover:text-blue-800 hover:underline break-all"
                      }, null, 8, ["domain"])),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.target ,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(record.record.priority), 1),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  (record.record.priority === minPriority.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Primary"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, "No mail servers found."))
}
}

})